import { useQuery } from "@vue/apollo-composable";
import { MeAuthDocument } from "~/graphql/generated/graphql";

export const useMe = () => {
  const meQuery = useQuery(MeAuthDocument);

  return meQuery;
};
